import src from "IMAGE";
export default { src, width: 900, height: 900, blurWidth: 0, blurHeight: 0};
